import React from 'react'
import { Typography } from '@mui/material'

import { InstructorColumnType } from '../instructorsDataGridColumns'

export const traineesColumnModel: InstructorColumnType = {
  field: 'traineeCount',
  width: 100,
  renderCell: (params) => (
    <Typography variant="subtitle1" fontWeight={500}>{params.value}</Typography>
  )
}
